import { http } from './http';
import { defineQuery, invalidateQueries, patchQueries } from './queryCache';
import { periodPreset } from '../utils/reportAnalytics';

const invalidateQRs = () => ['qrcodes', 'qr-inventory', 'qr', 'reports'].forEach(scope => invalidateQueries(scope));
export const qrCodeService = {
  list: defineQuery('qrcodes', params => http.get('/qrcodes', { params }).then(r => r.data), {
    ttl: 60000, normalize: ({ page = 1, limit = 12, search = '' } = {}) => ({ page, limit, search: search.trim().toLowerCase() })
  }),
  get: defineQuery('qr', id => http.get(`/qrcodes/${id}`).then(r => r.data)),
  create: async data => {
    const response = await http.post('/qrcodes', data);
    invalidateQRs();
    return response.data;
  },
  update: async data => {
    const response = await http.put('/qrcodes', data);
    const updated = response.data;
    patchQueries('qrcodes', result => ({ ...result, items: (result.items || []).map(qr => qr.id === updated.id ? { ...qr, ...updated } : qr) }));
    patchQueries('qr-inventory', items => items.map(qr => qr.id === updated.id ? { ...qr, ...updated } : qr));
    patchQueries('qr', qr => qr.id === updated.id ? { ...qr, ...updated } : qr);
    // Search membership can change when a name or destination changes.
    invalidateQueries('qrcodes', { match: params => !!params.search });
    invalidateQueries('reports');
    return updated;
  },
  delete: async id => {
    const response = await http.delete(`/qrcodes/${id}`);
    invalidateQRs();
    return response.data;
  }
};
qrCodeService.inventory = defineQuery('qr-inventory', async (_, options) => {
  const all = [];
  let page = 1, data;
  do {
    data = await qrCodeService.list({ page: page++, limit: 1000 }, options);
    all.push(...(data.items || []));
  } while (data.hasMore);
  return all;
}, { ttl: 60000 });
export const reportService = {
  get: defineQuery('reports', params => http.get('/reports', { params }).then(r => r.data), {
    normalize: ({ qrId = '', startDate = '', endDate = '' } = {}) => ({ qrId, startDate, endDate })
  })
};
export const reportFilters = filters => ({
  qrId: filters.qrId || '',
  startDate: filters.startDate ? `${filters.startDate}T00:00:00.000Z` : '',
  endDate: filters.endDate ? `${filters.endDate}T23:59:59.999Z` : ''
});
export const recentReportFilters = () => reportFilters(periodPreset(30));
export const templateService = {
  list: defineQuery('templates', () => http.get('/templates').then(r => r.data), { ttl: 60000 }),
  get: defineQuery('template', id => http.get(`/templates/${id}`).then(r => r.data)),
  create: async data => {
    const response = await http.post('/templates', data);
    invalidateQueries('templates');
    return response.data;
  },
  delete: async id => {
    const response = await http.delete(`/templates/${id}`);
    invalidateQueries('templates'); invalidateQueries('template');
    return response.data;
  }
};